import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useId } from 'react-id-generator';
import lockIcon from 'public/static/images/lock.svg';
import authPass from './auth-pass.svg';
import authFail from './auth-fail.svg';
import styles from './styles';

interface FormFieldProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  type: string;
  label: string;
  error: string;
  showValidationIcon: boolean;
  disabled?: boolean;
  locked?: boolean;
  className?: string;
  onValidation?: (validationError: string) => void;
  value?: string;
}

function validationIcon(showValidationIcon: boolean, error: string): string {
  if (showValidationIcon && error) {
    return authFail;
  }
  if (showValidationIcon && !error) {
    return authPass;
  }
  return '';
}

const FormField = ({
  type,
  label,
  error,
  showValidationIcon,
  className = '',
  onValidation,
  value,
  onBlur,
  locked = false,
  disabled,
  ...otherProps
}: FormFieldProps): JSX.Element => {
  const [id] = useId();

  const valueProp = value ? { value } : {};
  return (
    <div className={`field ${className} ${locked ? 'locked' : ''}`}>
      {locked ? (
        <img className="locked-icon" src={lockIcon} />
      ) : (
        <img
          className="validation-icon"
          src={validationIcon(showValidationIcon, error)}
          data-testid={`${label} validation icon`}
        />
      )}
      <input
        id={id}
        className={error && showValidationIcon ? 'validation-error' : ''}
        {...otherProps}
        {...valueProp}
        disabled={locked || disabled}
        value={value}
        type={type}
        required
        formNoValidate
        onBlur={(event): void => {
          if (onBlur) {
            onBlur(event);
          }

          if (onValidation) {
            onValidation(error);
          }
        }}
      />
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      {showValidationIcon && (
        <label className="error-label" htmlFor={id}>
          {error}
        </label>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

export default FormField;
